import {AxiosResponse} from 'axios'
import {RawPagedCollectionResponse, RawPersonTargetFeature} from '../types'
import {HttpInstance} from '../createHttpInstance'

interface Params {
  ClientID: number
  PageNumber: number
  PageSize: number
  FeatureID?: number
  TargetPersonID?: number
}

type ListPersonTargetFeaturesResponse =
  RawPagedCollectionResponse<RawPersonTargetFeature>

export interface ListPersonTargetFeatures<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const listPersonTargetFeatures: ListPersonTargetFeatures<
  Params,
  ListPersonTargetFeaturesResponse
> = (http, {ClientID, PageNumber, PageSize, FeatureID, TargetPersonID}) => {
  try {
    const queryParams: string[] = []
    queryParams.push(`clientid=${ClientID}`)
    queryParams.push(`pagenumber=${PageNumber}`)
    queryParams.push(`pagesize=${PageSize}`)
    if (FeatureID !== undefined) {
      queryParams.push(`featureid=${FeatureID}`)
    }
    if (TargetPersonID !== undefined) {
      queryParams.push(`targetpersonid=${TargetPersonID}`)
    }
    const query = `?${queryParams.join('&')}`

    return http.get<ListPersonTargetFeaturesResponse>(
      `/v1/featuresettings/persontarget${query}`,
    )
  } catch (e) {
    if (e instanceof Error) {
      throw e
    } else {
      throw new Error(e as string)
    }
  }
}
